/**
 * The shape of a user metadata key: letters, digits, `-` or `_`, never a leading
 * `_`, at most 64 characters. The retrieval index refuses a key that starts with
 * `_` or `$` or is longer than 64 bytes, and one refused key fails the whole
 * write batch. The charset is ASCII, so 64 characters are 64 bytes. A colon is
 * outside the charset, which keeps every user key apart from the index's own
 * `chunk:*` fields.
 */
export const DOCUMENT_METADATA_KEY_PATTERN = /^[A-Za-z0-9-][A-Za-z0-9_-]{0,63}$/;

/** The message every door prints when a key fails {@link DOCUMENT_METADATA_KEY_PATTERN}. */
export const DOCUMENT_METADATA_KEY_RULE =
  "a metadata key uses letters, digits, - or _, does not start with _, and is at most 64 characters";
